import { AbsRemixPage } from '@lemon8/web-app-shared/ssr';
import { useAtomValue } from 'jotai';
import { $SharingCurrentTraffic } from 'shared/atoms';
import { useLocation } from '@remix-run/react';
import { Loading } from '~/components/loading';

export abstract class SharingRemixPage extends AbsRemixPage {
  HeadSkeleton = () => {
    return (
      <>
        <title>Lemon8 Loading...</title>
      </>
    );
  };
  BodySkeleton = () => {
    return (
      <>
        <Loading variant="ball" />
      </>
    );
  };

  useRouteLoading = () => {
    const { canonicalUrl } = useAtomValue($SharingCurrentTraffic);

    if (__BUILD_TARGET__ === 'server') {
      return false;
    }

    const a = new URL(canonicalUrl);
    return location.pathname !== a.pathname;
  };
}
